import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import axiosInstance from "../../../api/api";
import { Link } from 'react-router-dom';

function CiuuList(ciemId) {
    const [actividades, setActividades] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        id: '',
        actividadPrincipal: '',
        actividadSecundaria: '',
        otraActividad: '',
        ciemId: ciemId.ciemId,
    });
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {

            const response = await axiosInstance.get('/ciuu/' + ciemId.ciemId); // Reemplaza con la URL de tu API
            setActividades(response.data.data);
            console.log("ciuu")
            console.log(actividades)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setFormData({
            id: '',
            actividadPrincipal: '',
            actividadSecundaria: '',
            otraActividad: '',
            ciemId: ciemId.ciemId,
        });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosInstance.post('/ciuu/', formData); // Reemplaza con la URL de tu API
            fetchData();
            handleCloseModal();
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Está seguro de que desea eliminar este registro?')) return;
        try {
            await axiosInstance.delete(`/ciuu/${id}`);
            alert('Registro eliminado correctamente');
            fetchData();
        } catch (error) {
            const msg = error.response?.data?.message || error.message;
            alert('Error al eliminar: ' + msg);
            console.error('Error eliminando ciuu:', msg);
        }
    };

    const handleEdit = (actividad) => {
        setFormData({
            id: actividad.id,
            actividadPrincipal: actividad.actividadPrincipal,
            actividadSecundaria: actividad.actividadSecundaria,
            otraActividad: actividad.otraActividad,
            ciemId: ciemId.ciemId
        });
        handleShowModal();
    };

    return (
        <div>
            <Button variant="primary" onClick={handleShowModal}>
                Crear Actividad
            </Button>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Actividad Principal</th>
                        <th>Actividad Secundaria</th>
                        <th>Otra Actividad</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {actividades.map((actividad) => (
                        <tr key={actividad.id}>
                            <td>{actividad.actividadPrincipal}</td>
                            <td>{actividad.actividadSecundaria}</td>
                            <td>{actividad.otraActividad}</td>
                            <td>
                                <Button variant="info" onClick={() => handleEdit(actividad)}>
                                    Editar
                                </Button>{' '}
                                <Button variant="danger" onClick={() => handleDelete(actividad.id)}>
                                    Eliminar
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editId ? 'Editar Actividad' : 'Crear Actividad'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formActividadPrincipal">
                            <Form.Label>Actividad Principal</Form.Label>
                            <Form.Control
                                type="text"
                                name="actividadPrincipal"
                                value={formData.actividadPrincipal}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="formActividadSecundaria">
                            <Form.Label>Actividad Secundaria</Form.Label>
                            <Form.Control
                                type="text"
                                name="actividadSecundaria"
                                value={formData.actividadSecundaria}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="formOtraActividad">
                            <Form.Label>Otra Actividad</Form.Label>
                            <Form.Control
                                type="text"
                                name="otraActividad"
                                value={formData.otraActividad}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Guardar
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default CiuuList;